window.REQUIRED_CODE_ERROR_MESSAGE = 'Please choose a country code';
window.LOCALE = 'en';
window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "Die eingegebenen Informationen weisen Fehler auf. Bitte überprüfen Sie die Felder und versuchen Sie es erneut.";
window.REQUIRED_ERROR_MESSAGE = "Dieses Feld darf nicht leer bleiben. ";
window.GENERIC_INVALID_MESSAGE = "Die eingegebenen Informationen weisen Fehler auf. Bitte überprüfen Sie die Felder und versuchen Sie es erneut.";

window.translation = {
  common: {
    selectedList: '{quantity} list selected',
    selectedLists: '{quantity} lists selected'
  }
};

var AUTOHIDE = Boolean(0);
